import React from 'react';
import './styles.css';

function Title(props) {
  return <h2 className={'section-title'}>{props.children}</h2>;
}

export default Title;
